<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useConfirmStore } from '@/store/confirm.ts'

const confirmStore = useConfirmStore()

const { confirm } = storeToRefs(confirmStore)
const { closeConfirm } = confirmStore

async function onConfirm(): Promise<void> {
  if (confirm.value.confirmCallback) {
    await confirm.value.confirmCallback()
  }
  closeConfirm()
}

async function onCancel(): Promise<void> {
  if (confirm.value.cancelCallback) {
    await confirm.value.cancelCallback()
  }
  closeConfirm()
}

async function onCloseable(): Promise<void> {
  if (confirm.value.closeableCallback) {
    await confirm.value.closeableCallback()
  }
  closeConfirm()
}
</script>
<template>
  <div>
    <VDialog
      :model-value="confirm.active"
      :close-on-click-outside="confirm.closeable"
      @update:model-value="closeConfirm"
      data-test="dialog"
    >
      <VDialogCard
        :title="confirm.title"
        class="w-[550px]"
        :hide-close="!confirm.closeable"
        @close="onCloseable"
        data-test="dialog-card"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-html="confirm.description"
          data-test="description"
        />
        <template #actions>
          <VButton
            variant="outlineSubtle"
            :disabled="confirm.loading"
            @click="onCancel"
            data-test="cancel-button"
          >
            {{ confirm.cancelText }}
          </VButton>
          <VButton
            variant="fill"
            :loading="confirm.loading"
            @click="onConfirm"
            data-test="confirm-button"
          >
            {{ confirm.confirmText }}
          </VButton>
        </template>
      </VDialogCard>
    </VDialog>
  </div>
</template>
